import { memo, PropsWithChildren, ReactElement } from 'react';
import { Box } from '@mui/material';

export const FilterHeaderLayout = memo(function ({ children }: PropsWithChildren): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        justifyItems: 'center',
        marginBottom: 1,
      }}
    >
      {children}
    </Box>
  );
});
